// Copyright (c) 2023 Deere & Company

import DuplicatePINPlate from '@deere/cps-it.warranty-model-factory/lib/duplicate-pin-plate';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updatePIN = (state, action) =>
DuplicatePINPlate.update(state, {
    pin: {
        $set: action.pin
    }
});

const updateDuplicatePlate = (state, action) =>
DuplicatePINPlate.update(state, {
    $set: action.data
});

const updateDuplicatePinPlate = (state, action) =>
DuplicatePINPlate.update(state, {
    [action.property]: {
        $set: action.value
    }
});

const updateMachineModel = (state, action) =>
DuplicatePINPlate.update(state, {
    machineModel: {
        $set: action.machineModel
    }
});

const updateRequesterTSCM = (state, action) =>
DuplicatePINPlate.update(state, {
    requesterTCSM: {
        $set: action.requesterTCSM
    }
});

const updateMissingPlateReason = (state, action) =>
DuplicatePINPlate.update(state, {
    missingPlateReason: {
        $set: action.missingPlateReason
    }
});

const updateDealerLocation = (state, action) =>
    DuplicatePINPlate.update(state, {
        dealer: {
            account: {
                $set: action.account
            }
        }
    });

const updateMailingRecipient = (state, action) =>
DuplicatePINPlate.update(state, {
    mailingRecipient: {
        $set: action.mailingRecipient
    }
});

const updateAddressLine1 = (state, action) =>
DuplicatePINPlate.update(state, {
    dealer: {
        location: {
            address1: {
                $set: action.address1
            }
        }
    }
});

const updateAddressLine2 = (state, action) =>
DuplicatePINPlate.update(state, {
    dealer: {
        location: {
            address2: {
                $set: action.address2
            }
        }
    }
});

const updateCity = (state, action) =>
DuplicatePINPlate.update(state, {
    dealer: {
        location: {
            city: {
                $set: action.city
            }
        }
    }
});

const updateZipCode = (state, action) =>
DuplicatePINPlate.update(state, {
    dealer: {
        location: {
            postalCode: {
                $set: action.postalCode
            }
        }
    }
});

const updateState = (state, action) =>
DuplicatePINPlate.update(state, {
    dealer: {
        location: {
            state: {
                $set: action.state
            }
        }
    }
});

const updateCountry = (state, action) =>
DuplicatePINPlate.update(state, {
    dealer: {
        location: {
            country: {
                $set: action.country
            }
        }
    }
});

const updatePhone = (state, action) =>
DuplicatePINPlate.update(state, {
    dealer: {
        phone: {
            $set: action.phone
        }
    }
});

const updateInstructions = (state, action) =>
DuplicatePINPlate.update(state, {
    instruction: {
        $set: action.instruction
    }

});

const updateFile = (state, action) =>
DuplicatePINPlate.update(state, {
    file: {
        $push: [action.file]
    }
});

const deleteFile = (state, action) => {

    const index = state.file.findIndex(file => file.fileName === action.data.fileName);

    return DuplicatePINPlate.update(state, {
        file: {
            $splice: [[index, 1]]
        }
    });

};

export default (state = getDefaultState().duplicatePINPlate, action) => {

    const actionTypes = {
        [actions.DELETE_DUPLICATE_PIN_PLATE_FILE]: deleteFile,
        [actions.RESET_DUPLICATE_PIN_PLATE]: updateDuplicatePlate,
        [actions.UPDATE_PIN_PLATE_REQUEST]: updateDuplicatePlate,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_ADDRESS1]: updateAddressLine1,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_ADDRESS2]: updateAddressLine2,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_CITY]: updateCity,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_COUNTRY]: updateCountry,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_DEALER_LOCATION]: updateDealerLocation,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_FILE]: updateFile,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_INFORMATION]: updateDuplicatePinPlate,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_INSTRUCTIONS]: updateInstructions,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_MACHINE_MODEL]: updateMachineModel,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_MAILING_RECIPIENT]: updateMailingRecipient,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_MISSING_PLATE_REASON]: updateMissingPlateReason,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_PHONE]: updatePhone,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_REQUESTER_TCSM]: updateRequesterTSCM,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_STATE]: updateState,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_PIN]: updatePIN,
        [actions.UPDATE_DUPLICATE_PIN_PLATE_ZIP_CODE]: updateZipCode

    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};




// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/reducers/duplicate-pin-plate.js